import { useEffect, useState } from 'react';
import { videoCaptureUiMode } from '../utils/videoCaptureLayout';

// Reusable mobile detection hook
// - breakpoint: width threshold for mobile regardless of touch
// - touchBreakpoint: width threshold when touch capability is present
// Content-creator capture tabs pass ?videoCapture=desktop|mobile so the Trade
// UI follows that choice even when the window size would say otherwise.
export const useIsMobile = (breakpoint = 768, touchBreakpoint = 1024) => {
  const getIsMobile = () => {
    try {
      const capture = videoCaptureUiMode();
      if (capture === 'mobile') return true;
      if (capture === 'desktop') return false;
      const hasTouch = typeof window !== 'undefined' && 'ontouchstart' in window;
      const width = typeof window !== 'undefined' ? window.innerWidth : 1920;
      return width <= breakpoint || (hasTouch && width <= touchBreakpoint);
    } catch (_) {
      return false;
    }
  };

  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener('resize', handleResize, { passive: true });
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint, touchBreakpoint]);

  return isMobile;
};

export default useIsMobile;

/** True when viewport width is at or below maxWidth (px). */
export const useMaxWidth = (maxWidth) => {
  const getMatches = () => {
    try {
      return typeof window !== 'undefined' && window.innerWidth <= maxWidth;
    } catch (_) {
      return false;
    }
  };

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [maxWidth]);

  return matches;
};


